export const sanitizeCsvValue = (value: string | undefined | null): string => {
  if (!value) return '';

  let sanitized = value.trim();

  const formulaChars = ['=', '+', '-', '@', '\t', '\r', '\n'];

  while (formulaChars.some((char) => sanitized.startsWith(char))) {
    sanitized = sanitized.substring(1).trim();
  }

  return sanitized;
};

export const sanitizeForDisplay = (
  value: string | undefined | null,
): string => {
  if (!value) return '';

  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/\//g, '&#x2F;');
};

export const sanitizeCsvRow = <T extends Record<string, any>>(row: T): T => {
  const sanitized = { ...row };

  for (const key in sanitized) {
    if (typeof sanitized[key] === 'string') {
      sanitized[key] = sanitizeCsvValue(sanitized[key]) as any;
    }
  }

  return sanitized;
};
